define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    var input = $('<input type="text"/>');
    var supportsPlaceholder = 'placeholder' in input;
    function showWatermarkAsText($child) {
        if ($child.val() === '') {
            $child.val($child.attr('placeholder'));
            $child.css({ 'opacity': '0.65' });
        }
    }
    function inputWatermark(sel, action) {
        if (!supportsPlaceholder) {
            sel.each(function (i, child) {
                var $child = $(child);
                if (!action) {
                    showWatermarkAsText($child);
                    $child.blur(function () { return showWatermarkAsText($child); });
                    $child.focus(function () {
                        if ($child.val() === $child.attr('placeholder')) {
                            $child.val($child.attr('userInput') || '');
                            $child.css({ 'opacity': '1.0' });
                            $child.removeAttr('userInput');
                        }
                    });
                }
                else if (action === 'reset') {
                    showWatermarkAsText($child);
                }
            });
        }
        return sel;
    }
    (function ($) {
        $.fn.inputWatermark = function (action) { inputWatermark(this, action); };
    })($);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/input-watermark.js
// module id = 17
// module chunks = 0